import React, { useMemo } from 'react';

import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { useGuardianPlayersQuery } from '@/features/guardian/queries';
import { createStyles, useScaling } from '@/hooks';
import { useSessionStore } from '@/stores/session-store';
import { guardianColors } from '@/theme/colors';
import NewNoteCard from './card';
import type { NewNotesSectionProps } from './types';
import { getCoachNotesFromGuardianPlayers } from './utils';

const strings = STRINGS.guardian.home.newNotes;

function NewNotesSection({ onNotePress, style }: NewNotesSectionProps) {
  const styles = useStyles();
  const { scale } = useScaling();
  const uid = useSessionStore(s => s.user?.uid);
  const { data: guardianPlayers } = useGuardianPlayersQuery(uid);
  const listNotes = useMemo(
    () => getCoachNotesFromGuardianPlayers(guardianPlayers),
    [guardianPlayers],
  );

  if (listNotes.length === 0) return null;

  return (
    <Stack style={[styles.root, style]}>
      <Stack style={styles.header}>
        <Text variant="Font Guardian App/Body/Body 16 Bold" style={styles.title}>
          {strings.title}
        </Text>
      </Stack>

      <Stack gap={scale(8)} paddingTop={scale(8)}>
        {listNotes.map((note, index) => (
          <NewNoteCard
            key={`${note.coachName}-${note.date}-${note.title}-${index}`}
            note={note}
            onPress={onNotePress}
          />
        ))}
      </Stack>
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  root: {
    paddingHorizontal: scale(20),
  },
  header: {
    paddingBottom: scale(8),
  },
  title: {
    color: guardianColors['10'],
  },
}));

export type { CoachNote, NewNotesSectionProps } from './types';
export default NewNotesSection;
